module.exports = __webpack_public_path__ + "img/tab_zhongnongwang_1.5a905b13.png";